import { render, staticRenderFns } from "./SubmissionEditModal.vue?vue&type=template&id=9e5a7232&scoped=true"
import script from "./SubmissionEditModal.vue?vue&type=script&lang=js"
export * from "./SubmissionEditModal.vue?vue&type=script&lang=js"
import style0 from "./SubmissionEditModal.vue?vue&type=style&index=0&id=9e5a7232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5a7232",
  null
  
)

export default component.exports